import React from 'react';
export default function Strike(props) {
    return (React.createElement("span", { style: { textDecoration: 'line-through' } }, props.children));
}
//# sourceMappingURL=strike.js.map